<template>
  <div class="share-button">
    <BaseButton
      class="button-small button-outline"
      v-bind="$attrs"
      icon-after="share"
      @click="shareItem"
    >
      {{ $t("share.button-text") }}
    </BaseButton>
    <ClientOnly>
      <ShareMenu v-if="showShareMenu" ref="shareMenu" :url="url" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const { share, isSupported } = useShare();

const props = defineProps<{
  item: {
    text?: string | null;
    title: string;
    url?: string;
  };
}>();

const showShareMenu = ref(false);

const { t } = useI18n();

const shareItem = () => {
  if (isSupported.value) {
    // Use the native share API
    share({
      text: t("share.default-share-text"),
      ...props,
    });
  } else {
    // Open the share menu
    showShareMenu.value = true;
  }
};

// Handle clicks outside to close the share menu
const shareMenu = ref(null);
onClickOutside(shareMenu, () => {
  showShareMenu.value = false;
});

const url = computed(() => {
  return props.item.url ?? window.location.href;
});
</script>

<style lang="scss" scoped>
.share-button {
  position: relative;
}
</style>
